// Web env: injected by webpack.EnvironmentPlugin at build time.
import { resolveApiBaseUrl } from './apiBaseUrl';
import type { UiConfig } from './config';

function req(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`config: missing required env ${name} (see apps/ui/.env.example)`);
  }
  return value;
}

export const config: UiConfig = {
  entraTenantId: req('ENTRA_TENANT_ID', process.env.ENTRA_TENANT_ID),
  entraClientId: req('ENTRA_CLIENT_ID', process.env.ENTRA_CLIENT_ID),
  entraApiScope: req('ENTRA_API_SCOPE', process.env.ENTRA_API_SCOPE),
  // EnvironmentPlugin substitutes a value for every declared key, so '' — not undefined —
  // is what "unset" means. A production bundle therefore carries the empty string and the
  // override branch is dead code there, which is why it cannot be forgotten into a release.
  entraIssuer: process.env.ENTRA_ISSUER ?? '',
  entraRedirectUri: process.env.ENTRA_REDIRECT_URI ?? '',
  // same-origin in prod (the API serves this build); localhost proxy for dev.
  // EnvironmentPlugin always substitutes a value, so emptiness — not
  // `undefined` — is what means "unset" here (see ./apiBaseUrl).
  apiBaseUrl: resolveApiBaseUrl(
    process.env.API_BASE_URL,
    typeof window !== 'undefined' ? window.location : undefined,
  ),
};
